
<div style="display: flex;justify-content: center; align-items: center; width: 100%; height: 100%;">
   <div style="display: flex; justify-content: center; align-items: center;flex-direction: column; width: 50%; padding: 2vh;">
    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>image URL</mat-label>
        <input [(ngModel)]="imageUrl" matInput placeholder="Type the image url to convert into base64">
      </mat-form-field>

      <button mat-raised-button (click)="handleConvert()" style="margin-bottom: 2vh;">Convert to base64 </button>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Output</mat-label>
        <textarea [(ngModel)]="result" rows="40" matInput placeholder=""></textarea>
      </mat-form-field>
   </div>
</div>